import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { ICheckIn } from 'src/app/models/check-in';
import { IWorkingStatus, IProductLine } from 'src/app/models/map';
import { WORKING_STATUS } from 'src/app/helper/constants';
import { checkInDataSelector, checkInArrayDataSelector } from 'src/app/app-store/check-in/check-in.selector';
import { select, Store } from '@ngrx/store';
import workingStatus from '../../../../assets/working-status.json';
import { mapsPayload } from 'src/app/app-store/map/map.selector';
import { IProxyGroup } from 'src/app/models/proxy-group.js';
import { IProxyActiveCheckIn } from 'src/app/models/user.js';



export interface DialogData {
  name: string;
  jobTitle: string;
  contactNumber: string;
  company: string;
}

@Component({
  selector: 'app-details-dialog',
  templateUrl: 'detailsdialog.component.html',
  styleUrls: ['./detailsdialog.component.css']
})


export class DetailsDialogComponent implements OnInit, OnDestroy {


  name: string;
  jobTitle: string;
  contactNumber: string;
  company: string;
  TodayDate = new Date();
  checkinDataSubscription: Subscription;

  checkInObject: ICheckIn;
  statusTitle: string;
  statusTitleLocal: string;
  statusImage: string;
  statusName: string;
  isInsideQuarantineorIsolationPage = false;
  FromWorkonSite = false;
  FromTraining = false;
  FromBusinnessTrip = false;
  workingStatus: IWorkingStatus[] = workingStatus;
  statusNameToCompare = WORKING_STATUS;
  productLines: IProductLine[];
  productLineName: string;
  proxyCheckInArray: ICheckIn[];
  checkInArrayDataSelectorSubscription: Subscription;
  mapsPayloadsubscription: Subscription;



  constructor(private router: Router, private store: Store,
              public dialogRef: MatDialogRef<DetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IProxyActiveCheckIn) {

  }

  ngOnInit() {

    this.mapsPayloadsubscription = this.store.pipe(select(mapsPayload)).subscribe(response => {
      if (response !== undefined) {
        this.productLines = response.productLines;

      }
    });

    this.checkInArrayDataSelectorSubscription = this.store.pipe(select(checkInArrayDataSelector)).subscribe(response => {
      if (response !== undefined) {
        this.proxyCheckInArray = response;
      }
    });

    // this.proxyCheckInArray = this.proxyCheckInArray.map((item, i) => ({ ...item, ...finalObject }));

    this.checkinDataSubscription = this.store.pipe(select(checkInDataSelector)).subscribe(response => {
      if (response !== undefined) {
        this.checkInObject = response;
        this.statusTitle = this.checkInObject.workingStatusName;
        this.statusTitleLocal = this.checkInObject.workingStatusLocalText;
        if (this.checkInObject.workingStatusName === this.statusNameToCompare.Working_On_Site) {
          this.FromWorkonSite = true;
        }
        if (this.checkInObject.workingStatusName === this.statusNameToCompare.Training) {
          this.FromTraining = true;
        }
        if (this.checkInObject.workingStatusName === this.statusNameToCompare.On_Business_Trip) {
          this.FromBusinnessTrip = true;
        }
        this.statusImage = this.workingStatus.filter(x => x.id === this.checkInObject.workingStatusId)[0].image;

        this.productLineName = this.productLines.filter(x => x.code === this.checkInObject.productLineCode)[0].name;
      }

    });



  }

  ngOnDestroy() {
    if (this.checkInArrayDataSelectorSubscription) {
      this.checkInArrayDataSelectorSubscription.unsubscribe();
    }
    if (this.checkinDataSubscription) {
      this.checkinDataSubscription.unsubscribe();
    }
    if (this.mapsPayloadsubscription) {
      this.mapsPayloadsubscription.unsubscribe();
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
